import type { Commit, CommitId } from "~/branching/model/commit";

/** Minimal snapshot fields used for domain Commit (HTTP + in-memory adapters). */
export type CommitSnapshotSource = {
  id: string;
  created?: string | Date | null;
  createdById?: string | null;
  message?: string | null;
  configurationId?: string | null;
};

export function toCommit(snapshot: CommitSnapshotSource): Commit {
  return {
    id: snapshot.id as CommitId,
    createdAt: snapshot.created ? new Date(snapshot.created) : null,
    createdById: snapshot.createdById ?? null,
    message: snapshot.message ?? null,
    configurationId: snapshot.configurationId ?? null,
  };
}
